import { Content, Page, Header } from '@backstage/core-components';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FeaturedSection } from './components/FeaturedSection';
import { QuickLinksGrid } from './components/QuickLinksGrid';
import { BlogPostsGrid } from './components/BlogPostsGrid';
import { ResourcesSection } from './components/ResourcesSection';
import { AiToolsSection } from './components/AiToolsSection';
import { NewsletterSection } from './components/NewsletterSection';
import { McpServersTable } from './components/McpServersTable';
import { FeaturedReadingSection } from './components/FeaturedReadingSection';
import { LatestReleasesSection } from './components/LatestReleasesSection';

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(0, 2),
  },
}));

export const AiCentralPage = () => {
  const classes = useStyles();

  return (
    <Page themeId="tool">
      <Header
        title="AI Central"
        subtitle="Your hub for AI resources, tools, and best practices at AvidXchange"
      />
      <Content>
        <Grid container spacing={3} className={classes.container}>
          <Grid item xs={12}>
            <FeaturedSection />
          </Grid>
          <Grid item xs={12}>
            <QuickLinksGrid />
          </Grid>
          <Grid item xs={12} md={8}>
            <BlogPostsGrid />
          </Grid>
          <Grid item xs={12} md={4}>
            <NewsletterSection />
          </Grid>
          <Grid item xs={12}>
            <FeaturedReadingSection />
          </Grid>
          <Grid item xs={12}>
            <LatestReleasesSection />
          </Grid>
          <Grid item xs={12} md={6}>
            <ResourcesSection />
          </Grid>
          <Grid item xs={12} md={6}>
            <AiToolsSection />
          </Grid>
          <Grid item xs={12}>
            <McpServersTable />
          </Grid>
        </Grid>
      </Content>
    </Page>
  );
};
